import { gql } from '@apollo/client';
const GET_COMPONENTS_HEADERS = gql `
  query GetComponentsHeaders($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        components {
          edges {
            node {
              id
              name
              productCategory {
                id
                type
                typeLabelPL
                typeLabelEN
                typeIcon
                variantHasSize
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_COMPONENTS_HEADERS;
